import { render, staticRenderFns } from "./AssignMetaTags.vue?vue&type=template&id=a8a9f5ca"
import script from "./AssignMetaTags.vue?vue&type=script&lang=js"
export * from "./AssignMetaTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports